import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import "firebase/database";
import VueAnalytics from "vue-analytics";

Vue.config.productionTip = true;

Vue.use(VueAnalytics, {
  id: "UA-139027844-1",
  router
});

var firebaseConfig = {
  apiKey: "AIzaSyAk__hCIPuCSB_Q_Xj-uoWvCZaoCHUkgUE",
  authDomain: "dsa-startplank.firebaseapp.com",
  databaseURL: "https://dsa-startplank.firebaseio.com",
  projectId: "dsa-startplank",
  storageBucket: "dsa-startplank.appspot.com",
  messagingSenderId: "1071174100044"
};

firebase.initializeApp(firebaseConfig);
export const db = firebase.database();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
